export default "__VITE_ASSET__CdiUNUV2__"